import { Box, Container } from '@chakra-ui/react';

import OrderList from '../../orderList/OrderList';
import { useLocation } from 'react-router-dom';
import findRoute from '../../../utils/findRoute';
import EmptyAlert from '../../emptyAlert/EmptyAlert';
import { useLazyGetOrdersQuery } from '../../../redux/platimarket/platimarket.api';
import Loader from '../../loader/Loader';
import { useEffect } from 'react';

export default function Orders() {
    const [
        fetchOrders,
        {
            data,
            isFetching: isLoadingOrders,
            isSuccess: isSuccessOrders,
            isError: isErrorOrders,
            error: errorOrders,
        },
    ] = useLazyGetOrdersQuery();

    const orders = data?.results;

    const location = useLocation();
    const pathName = location.pathname;

    const findedRoute = findRoute(pathName);
    const emptyMessage = findedRoute?.emptyMessage;

    useEffect(() => {
        fetchOrders({});
    }, []);

    return (
        <Container height="calc(100vh + 70px)">
            {isLoadingOrders ? (
                <Box display="flex" justifyContent="center" mt="30px">
                    <Loader />
                </Box>
            ) : orders?.length ? (
                <OrderList orders={orders} />
            ) : (
                <EmptyAlert localeMessage={emptyMessage} />
            )}
        </Container>
    );
}
